import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RegionItem, Tab3Input } from "../../model/calculations/calculation";

interface State {
    tab3Input: Tab3Input | null;
    loading: boolean;
    error: string | null;
    region: string | null,
    regionList: RegionItem[];
    selectedRegion: string | null;
    getSelectedRegion: {};
    fluidViscosityChangeMessage: string;
};

export const initialState: State = {
    tab3Input: null,
    loading: false,
    error: null,
    region: "",
    regionList: [],
    selectedRegion: "",
    getSelectedRegion: {},
    fluidViscosityChangeMessage: "",
};

export const fetchFluidViscosity = createAction("fluidTab/fetchFluidViscosity");
export const fetchBubblepoint = createAction("fluidTab/fetchBubblePoint");

const fluidTabSlice = createSlice({
    name: 'fluidTab',
    initialState,
    reducers: {
        resetFluidTab: () => ({
            ...initialState
        }),
        setFluidTabDetails: (state, action) => {
            return {
                ...state,
                tab3Input: action?.payload
            };
        },
        setSpGrWater: (state, action: PayloadAction<number>) => {
            if (state.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    spGrWater: action.payload
                };
            }
        },
        setWaterCut: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    waterCut: action.payload
                };
            }
        },
        setBwpd: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    bwpd: action.payload
                };
            }
        },
        setOilAPI: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    oilAPI: action.payload
                };
            }
        },
        setOilAPI2: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    oilAPI: action.payload
                };
            }
        },
        setSpGrOil: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    spGrOil: action.payload
                };
            }
        },
        setSpGrOil2: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    spGrOil: action.payload
                };
            }
        },
        setOilCut: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    oilCut: action.payload
                };
            }
        },
        setBopd: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    bopd: action.payload
                };
            }
        },
        setAverageCombinedSpGr: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    averageCombinedSpGr: action.payload
                };
            }
        },
        setLiquidPhaseCombinedSpGr: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    liquidPhaseCombinedSpGr: action.payload
                };
            }
        },
        setFluidViscosity: (state, action: PayloadAction<number | string>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    fluidViscosity: action?.payload
                };
            }
        },
        setGasProduction: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gasProduction: action.payload
                };
            }
        },
        setGasProduction2: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gasProduction: action.payload
                };
            }
        },
        setGOR: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gor: action.payload
                };
            }
        },
        setGOR2: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gor: action.payload
                };
            }
        },
        setGLR: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    glr: action.payload
                };
            }
        },
        setGLR2: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    glr: action.payload
                };
            }
        },
        setSpGrGas: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    spGrGas: action.payload
                };
            }
        },
        setGasCompressibility: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gasCompressibility: action.payload
                };
            }
        },
        setBubblePoint: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    bubblePoint: action.payload
                };
            }
        },
        setBottomHoleTemp: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    bottomHoleTemp: action.payload
                };
            }
        },
        setSurfaceTemperature: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    surfaceTemperature: action.payload
                };
            }
        },
        setOperatingFrequency: (state, action: PayloadAction<number>) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    operatngFreq: action.payload
                }
            }
        },
        setRegion: (state, { payload }) => ({
            ...state,
            region: payload
        }),
        setRegionList: (state, { payload }) => ({
            ...state,
            regionList: payload
        }),
        setSelectedRegion: (state, { payload }) => ({
            ...state,
            selectedRegion: payload
        }),
        setGetSelectedRegion: (state, { payload }) => ({
            ...state,
            getSelectedRegion: payload
        }),
        setWaterCutCombinedSpGr: (state, { payload }) => {
            if (state?.tab3Input) {
                const { averageCompositeSpGr, liquidPhaseSpGr, compositeSpGr } = payload;
                state.tab3Input = {
                    ...state.tab3Input,
                    averageCombinedSpGr: averageCompositeSpGr,
                    liquidPhaseCombinedSpGr: liquidPhaseSpGr,
                    combinedSpGr: compositeSpGr,
                }
            }
        },
        setWaterCtOilCt: (state, { payload }) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    oilCut: payload
                }
            }
        },
        setBopdValues: (state, { payload }) => {
            if (state?.tab3Input) {
                const { bopd, bwpd } = payload;
                state.tab3Input = {
                    ...state.tab3Input,
                    bopd: bopd,
                    bwpd: bwpd,
                }
            }
        },
        setGasCalValues: (state, { payload }) => {
            if (state?.tab3Input) {
                const { gasProduction, gor, glr } = payload;
                state.tab3Input = {
                    ...state.tab3Input,
                    gasProduction: gasProduction,
                    gor: gor,
                    glr: glr
                }
            }
        },
        setGasAvailability: (state, { payload }) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    gasAvailblty: payload,
                };
            }
        },
        setHiddenGasIp: (state, action) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    hiddenGasIPType: action.payload,
                };
            }
        },
        setHiddenOilIPType: (state, action) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    hiddenOilIPType: action.payload,
                };
            }
        },
        setHiddenAutoGasCompress: (state, action) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    hdnAutoGasCmpress: action.payload,
                };
            }
        },
        setHiddenBubblePoint: (state, action) => {
            if (state?.tab3Input) {
                state.tab3Input = {
                    ...state.tab3Input,
                    hdnAutoBBlPnt: action.payload,
                };
            }
        },
        setFluidViscosityChangeMessage: (state, action) => {
            state.fluidViscosityChangeMessage = action?.payload || "";
        },
    },
});

export const {
    resetFluidTab,
    setFluidTabDetails,
    setSpGrWater,
    setWaterCut,
    setBwpd,
    setOilAPI,
    setOilAPI2,
    setSpGrOil,
    setSpGrOil2,
    setOilCut,
    setBopd,
    setAverageCombinedSpGr,
    setLiquidPhaseCombinedSpGr,
    setFluidViscosity,
    setGasProduction,
    setGasProduction2,
    setGOR,
    setGOR2,
    setGLR,
    setGLR2,
    setSpGrGas,
    setGasCompressibility,
    setBubblePoint,
    setBottomHoleTemp,
    setSurfaceTemperature,
    setRegion,
    setRegionList,
    setSelectedRegion,
    setGetSelectedRegion,
    setWaterCutCombinedSpGr,
    setWaterCtOilCt,
    setBopdValues,
    setGasCalValues,
    setOperatingFrequency,
    setGasAvailability,
    setHiddenGasIp,
    setHiddenAutoGasCompress,
    setHiddenOilIPType,
    setHiddenBubblePoint,
    setFluidViscosityChangeMessage,
} = fluidTabSlice.actions;

export default fluidTabSlice.reducer;